<template>
    <a class="button toggle-button" :class="{ 'is-primary': active }" @click.prevent="setValue()">
        <span><slot></slot></span>
    </a>
</template>


<script>
    export default {
        name: 'toggle-button',
        props: ['value', 'active'],
        methods: {
            setValue() {
                this.$emit('input', this.value);
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/components/toggle-buttons/toggleButton.vue